export default (plataforma) => {
  switch (plataforma) {
    case "cfe":
      //return 'http://localhost:3200';
      return "https://pertobilingueadm.com.br/cfeServer";
    case "peij":
      // return 'http://localhost:3003';
      return "https://pertobilingueadm.com.br/peij";

    case "ijtestes":
      // return 'http://localhost:3003';
      return "https://inglesjuntos.com.br/ijdev";

    case "comunidade-server":
      //return 'http://localhost:3500';
      return "https://pertobilingueadm.com.br/publicoServer";

    default:
      // return 'http://localhost:3300';
      return "https://pertobilingueadm.com.br/pews";
    // return 'http://pertobilingueadm.com.br:21029';
    //return 'http://pertoeducacao.com.br:21312';
  }
};
